<div class="main">
    <div class="card-2 d-flex flex-dir-col gap-8">
        <div class="d-flex flex-dir-row just-space">
            <div class="d-flex">
                <span class="h8 grey">Shift:&nbsp;</span> <span class="h8-b w-7">{{formattedShiftDate}}</span><span
                    class="h8-b" style="padding-left:5px">{{direction}}</span>
                <img misToolTip [text]="'Marshall Required'" [position]="'top'" *ngIf="isMarshalsRequired" style="padding-left:5px"
                    src="{{imgSrc}}assets/icons/marshall-with-bg.svg" />                                                                                                                                                                  
            </div>


            <div class="status d-flex align-center">
                <span class="h-12 text-bold trip-status"
                    *ngIf="response?.tripDetails.status === 'Started'">ONGOING</span>
                <span class="h-12 text-bold trip-status"
                    *ngIf="response?.tripDetails.status === 'Ended'">COMPLETE</span>
                <span class="h-12 text-bold trip-status" *ngIf="response?.tripDetails.status === ''">NOT STARTED</span>
            </div>

        </div>
        <div class="d-flex flex-dir-col">
            <div class="d-flex gap-8">
                <div class="d-flex align-center"> <span class="h8 grey"> Planned:</span><span class="h8">
                        {{formattedPlannedStartTime}}</span>&nbsp;-&nbsp;<span class="h8">
                        {{formattedPlannedEndTime}}</span></div>
                <span class="grey"> | </span>
                <div> <span class="h8 grey"> Actual:</span><span class="h8"> {{formattedActualStartTime}} - </span><span
                        *ngIf="response?.tripDetails.actualEndTime===null">--:--</span><span
                        *ngIf="response?.tripDetails.actualEndTime!==null" class="h8">{{formattedActualEndTime}}</span>
                </div>
                <!-- <div *ngIf="response?.tripDetails.actualEndTime!=null"><span class="h8">{{formattedEndDate}}</span><span class="h8-b"> {{formattedEndTime}}</span></div> -->
            </div>

            <!-- <div class="d-flex just-space">
                <span  misToolTip  [text]="response?.tripDetails.plannedStartLocation.address" [position]="'right'" style="max-width: 129px;" class="h8 grey truncate">{{response?.tripDetails.plannedStartLocation.address}}</span>
                <span  misToolTip  [text]="response?.tripDetails.plannedEndLocation.address" [position]="'bottom'" style="max-width: 129px;" class="h8 grey truncate">{{response?.tripDetails.plannedEndLocation.address}}</span>
            </div> -->
        </div>

    </div>

    <hr style="border: 0.5px solid lightgray;" />
    <div class="card-1 d-flex flex-dir-col">
        <div style="padding-bottom: 16px;"><span class="h8 grey">Vendor:&nbsp;</span>
            <span class="h8-b">{{response?.tripDetails.vehicle?.vendor?.name}}</span>
            <span class="h8-b" *ngIf="!response?.tripDetails.vehicle?.vendor?.name">Not Assigned</span>
        </div>


        <div class="d-flex flex-dir-row just-space" style="padding-bottom: 8px; border-bottom: 1px dashed #E0E0E0;">
            <div class="d-flex flex-dir-row gap-11">
                <img style="width: 42px;height: 42px;border-radius: 50%;"
                    src="{{response?.tripDetails.driver?.driverImagePath}}" />
                <div class="d-flex flex-dir-col">
                    <div class="d-flex flex-dir-row gap-8">
                        <span misToolTip [text]="response?.tripDetails.driver?.name" [position]="'bottom'"
                            class="h-16 text-bold lh-24 truncate">{{response?.tripDetails.driver?.name}}</span>
                        <div class="vl grey"></div>
                        <span class="d-flex h-12 align-center"><img
                                src="{{imgSrc}}assets/icons/call.svg" />{{response?.tripDetails.driver?.phoneNumber}}</span>
                    </div>


                    <span class="h9 d-flex">{{response?.tripDetails.driver?.driverRating}} <img style="margin-left:3px"
                            src="{{imgSrc}}assets/icons/star.svg" /></span>

                </div>
            </div>

            <button misToolTip [text]="hasDeviceImei ?'Device Health'  : 'No driver device / in cab device found' " [position]="'right'" (click)="openDeviceHealthModal()"
                class="transparent-button device pointer-cursor"
                [ngClass]="{'disable':!hasDeviceImei}"
                ><img src="{{imgSrc}}assets/icons/device-health.svg"
                    alt=""></button>
        </div>

        <div style="padding-top:8px" class="d-flex flex-dir-row gap-8 align-center">


            <img style="width:45px;height:30px" src="{{imgSrc}}assets/icons/tour-Bus1.svg" alt="">


            <div class="card-1-child-2 d-flex flex-dir-col just-space width-100">
                <div class="d-flex flex-dir-row gap-8">
                    <span class="h8-b" misToolTip [text]="'Vehicle Number'"
                        [position]="'bottom'">{{response?.tripDetails.vehicle?.vehicleIdentification}}</span>
                    <div class="vl grey"></div>
                    <span class="h8" misToolTip [text]="'Vehicle ID'"
                        [position]="'bottom'">{{response?.tripDetails.vehicle?.vehicleId}}</span>
                    <div class="vl grey"></div>
                    <span class="h8" misToolTip [text]="'Vehicle Type'" [position]="'bottom'">
                        {{response?.tripDetails.vehicle?.vehicleType?.type}}({{response?.tripDetails.vehicle?.vehicleType?.maxCapacity}})</span>
                    <!-- <div><span class="h8-b">{{response?.tripDetails.vehicle?.vehicleId}}</span><span class="h8"> &#183; {{response?.tripDetails.vehicle?.vehicleType?.name}}({{response?.tripDetails.vehicle?.vehicleType?.maxCapacity}}) &#183; {{response?.tripDetails.vehicle?.vehicleIdentification}}</span></div>
                    <div *ngIf="response?.tripDetails.ismarshalRequired"><span class="h8 grey">Marshall Requested</span></div>
                 -->
                </div>

                <!-- <div class="d-flex align-center just-space">
                    <div class="d-flex gap-16"><span misToolTip  [text]="response?.tripDetails.driver?.name" [position]="'bottom'" style="max-width: 60px;" class="h8 truncate">{{response?.tripDetails.driver?.name}}  </span> <span class="h8">{{response?.tripDetails.driver?.phoneNumber}}</span></div>
                    <button misToolTip  [text]="'Device Health'" [position]="'right'" (click)="openDeviceHealthModal()"  class="transparent-button device pointer-cursor"><img src="assets/icons/device-health.svg" alt=""></button>
                </div> -->

                <span class="grey h9"> {{response?.tripDetails.vehicle?.vehicleType?.name}}</span>
            </div>
        </div>

        <div class="ticket-details" *ngIf="ticketDetails.length">

            <div class="ticket-details-header">Ticket Details</div>
    
            <div class="ticket-details-values">
                
               <div class="values-row" *ngFor="let ticket of ticketDetails">
                <span class="field-details">
                    <span class="field-name">{{ticket.ticketType | titlecase}}</span>
                    <span class="field-value">{{ticket.ticketId}}</span>
                </span>
                    <span class="ticket-management-link" (click)="openTicketDetails(ticket.ticketUrl)">View Ticket</span>
               </div>
            </div>
    
        </div>

    </div>


</div>